import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import { useDroppable } from "@dnd-kit/react";
import { getExpansionDateKey, getDateKey } from "@repo/structure";
import { useEstimateEditorSettings } from "@tools";
import { timelineCollisionDetection } from "@tools/EstimateEditor/utils/index";
import { TimelineExpandingDay } from "./TimelineExpandingDay";
import useStyle from "./TimelineExpandingComponent.style";
import classnames from "classnames";

export const TimelineExpandingWeek = observer(({
  week,
  expansions,
  nextWeekExpanded,
}) => {
  const classes = useStyle();
  const { allowEdition } = useEstimateEditorSettings();

  const isExpanded = Boolean(expansions?.get(getExpansionDateKey(week.startDate, false)));

  const { ref, isDropTarget } = useDroppable({
    id: `week-${week.startDate.getTime()}`,
    type: "week",
    data: {
      date: week.startDate,
      periods: week.days.length,
    },
    disabled: !allowEdition || isExpanded,
    collisionDetector: timelineCollisionDetection,
  })

  return (
    <div
      ref={ref}
      className={classnames(
        classes.body,
        classes.weekBody,
        isExpanded && classes.activeWeek,
        (isExpanded || nextWeekExpanded) && classes.activeWeekDivider,
        isExpanded && "preset-active-2",
        isDropTarget && classes.isOver,
      )}
    >
      {
        isExpanded &&
        week.days.map((day) => (
          <TimelineExpandingDay
            key={getDateKey(day)}
            day={day}
          />
        ))
      }
    </div>
  );
});

TimelineExpandingWeek.propTypes = {
  week: object.isRequired,
  expansions: object.isRequired,
  nextWeekExpanded: bool,
};

TimelineExpandingWeek.displayName = "TimelineExpandingWeek";
